/* eslint-disable no-unused-vars */
import Swal from "sweetalert2";
export default {
  namespaced: true,
  state: {
    codes: {
      loading: false,
      data: [],
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
    documents: {
      loading: false,
      data: [],
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
    lineItems: {
      loading: false,
      data: [],
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
    ocf18s: {
      loading: false,
      pagination: {
        current: null,
        total: null,
        data: [],
      },
    },
    // Kept for OHIP's OCF21B/OCF21BSentInvoices views, which reuse this module.
    OCF21B: {
      loading: false,
      data: [],
    },
    OCF21BSentInvoices: {
      loading: false,
      data: [],
    },
    approvedInvoicesLoading: false,
  },
  mutations: {
    SET_CODES: (state, data) => {
      state.codes.data = data;
    },
    SET_CODES_LOADING: (state, data) => {
      state.codes.loading = data;
    },
    SET_CODES_PAGINATION: (state, data) => {
      state.codes.pagination = data;
    },
    SET_DOCUMENTS: (state, data) => {
      state.documents.data = data;
    },
    SET_DOCUMENTS_LOADING: (state, data) => {
      state.documents.loading = data;
    },
    SET_DOCUMENTS_PAGINATION: (state, data) => {
      state.documents.pagination = data;
    },
    SET_LINE_ITEMS: (state, data) => {
      state.lineItems.data = data;
    },
    SET_LINE_ITEMS_LOADING: (state, data) => {
      state.lineItems.loading = data;
    },
    SET_LINE_ITEMS_PAGINATION: (state, data) => {
      state.lineItems.pagination = data;
    },
    SET_OCF18S_LOADING: (state, data) => {
      state.ocf18s.loading = data;
    },
    SET_OCF18S_PAGINATION: (state, data) => {
      state.ocf18s.pagination = data;
    },
    SET_OCF21B_DATA: (state, data) => {
      state.OCF21B.data = data;
    },
    SET_OCF21B_LOADING: (state, data) => {
      state.OCF21B.loading = data;
    },
    SET_OCF21B_SENT_INVOICES_DATA: (state, data) => {
      state.OCF21BSentInvoices.data = data;
    },
    SET_OCF21B_SENT_INVOICES_LOADING: (state, data) => {
      state.OCF21BSentInvoices.loading = data;
    },
    SET_APPROVED_INVOICES_LOADING: (state, data) => {
      state.approvedInvoicesLoading = data;
    },
  },
  actions: {
    // Kept for OHIP's OCF21B/OCF21BSentInvoices views, which reuse this module.
    getOCF21BInvoices: function ({ commit }) {
      commit("SET_OCF21B_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai/ocf21b`).then(
          (res) => {
            if (res.status == 200) {
              commit("SET_OCF21B_DATA", res.data.data);
            }
            commit("SET_OCF21B_LOADING", false);
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_OCF21B_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getOCF21BSentInvoices: function ({ commit }) {
      commit("SET_OCF21B_SENT_INVOICES_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .get(`hcai/ocf21b-sent-invoices`)
          .then((res) => {
            if (res.status == 200) {
              commit("SET_OCF21B_SENT_INVOICES_DATA", res.data.data);
            }
            commit("SET_OCF21B_SENT_INVOICES_LOADING", false);
            resolve(res.data.data);
          })
          .catch((err) => {
            commit("SET_OCF21B_SENT_INVOICES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          });
      });
    },
    approveOCF21BInvoices: function ({ commit }, payload) {
      commit("SET_APPROVE_INVOICES_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .post(`hcai/approve-ocf21b-invoice`, payload)
          .then((res) => {
            if (res.status == 200) {
              Swal.fire({
                title: "Approved successfully",
                text: "Selected clients approved successfully",
                icon: "success",
              });
            }
            commit("SET_APPROVE_INVOICES_LOADING", false);
            resolve(true);
          })
          .catch((err) => {
            commit("SET_APPROVE_INVOICES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          });
      });
    },
    approveAllOCF21B: function ({ state, commit }, status) {
      const newOCF21B = state.OCF21B.data.map((invoice) => {
        invoice.approved = status;
        return invoice;
      });
      commit("SET_OCF21B_DATA", newOCF21B);
    },
    getCodes: function ({ commit, state }, payload) {
      const vm = this;
      let url = `hcai-codes`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.code) {
          url = `${url}${payload.limit ? "&" : "?"}code=${payload.code}`;
        }
        if (payload.description) {
          url = `${url}${
            payload.limit || payload.code ? "&" : "?"
          }description=${payload.description}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_CODES_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_CODES_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_CODES_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.codes.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_CODES_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_CODES", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_CODES_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getDocuments: function ({ commit, state }, payload) {
      const vm = this;
      let url = `hcai-documents`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.type) {
          url = `${url}&type=${payload.type}`;
        }
        if (payload.status) {
          url = `${url}&status=${payload.status}`;
        }
        if (payload.patientId) {
          url = `${url}&patient_id=${payload.patientId}`;
        }
        if (payload.clientIds) {
          url = `${url}&client_ids=${encodeURIComponent(
            JSON.stringify(payload.clientIds)
          )}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_DOCUMENTS_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_DOCUMENTS_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_DOCUMENTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.documents.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_DOCUMENTS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DOCUMENTS", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_DOCUMENTS_LOADING", false);
            commit("SET_DOCUMENTS_PAGINATION", {
              total: 0,
              current: 1,
              data: [],
            });
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getBillingItemsForDocument: function (_, id) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai-documents/${id}/line-items`).then(
          (res) => {
            if (res.status == 200) {
              return resolve(res.data.data);
            }
            resolve(false);
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    generateLineItems: function (_, items) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post(`generate-hcai-line-items`, { items }).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
              errors: ((err || {}).data || {}).errors || [],
            });
          }
        );
      });
    },
    getLineItems: function ({ commit, state }, payload) {
      const vm = this;
      let url = `hcai-line-items`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.status) {
          url = `${url}&status=${payload.status}`;
        }
        if (payload.client_ids) {
          url = `${url}&client_ids=${payload.client_ids}`;
        }
        if (payload.start) {
          url = `${url}&start=${payload.start}`;
        }
        if (payload.end) {
          url = `${url}&end=${payload.end}`;
        }
        if (payload.patientId) {
          url = `${url}&patient_id=${payload.patientId}`;
        }
        if (payload.appointmentId) {
          url = `${url}&appointment_id=${payload.appointmentId}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_LINE_ITEMS_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_LINE_ITEMS_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_LINE_ITEMS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.lineItems.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_LINE_ITEMS_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_LINE_ITEMS", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_LINE_ITEMS_LOADING", false);
            commit("SET_LINE_ITEMS_PAGINATION", {
              total: 0,
              current: 1,
              data: [],
            });
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    submitLineItems: function (_, items) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post(`submit-hcai-line-items`, { items }).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
              errors: ((err || {}).data || {}).errors || [],
            });
          }
        );
      });
    },
    // A client's registered OCF18 numbers: { patientId } or { clientId } (user id).
    getOcf18Numbers: function (_, { patientId, clientId }) {
      const vm = this;
      const query = patientId
        ? `patient_id=${patientId}`
        : `client_id=${clientId}`;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai-ocf18-numbers?${query}`).then(
          (res) => resolve(res.data.data || []),
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    // payload: { patient_id | client_id, ocf18_number, description }
    createOcf18Number: function (_, payload) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post(`hcai-ocf18-numbers`, payload).then(
          (res) => resolve({ success: true, data: res.data.data }),
          (err) =>
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            })
        );
      });
    },
    updateOcf18Number: function (_, { id, ...changes }) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.put(`hcai-ocf18-numbers/${id}`, changes).then(
          (res) => resolve({ success: true, data: res.data.data }),
          (err) =>
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            })
        );
      });
    },
    deleteOcf18Number: function (_, id) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.delete(`hcai-ocf18-numbers/${id}`).then(
          () => resolve({ success: true }),
          (err) =>
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            })
        );
      });
    },
    getOcf18s: function ({ commit, state }, payload) {
      const vm = this;
      const params = new URLSearchParams();
      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          params.append(key, value);
        }
      });
      if (!payload || !payload.page) {
        commit("SET_OCF18S_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(`hcai-ocf18s?${params.toString()}`).then(
          (res) => {
            commit("SET_OCF18S_LOADING", false);
            commit("SET_OCF18S_PAGINATION", {
              total: res.data.meta.total,
              current: res.data.meta.current_page,
              data:
                payload && payload.page
                  ? [...state.ocf18s.pagination.data, ...res.data.data]
                  : res.data.data,
            });
            resolve(res.data.data);
          },
          (err) => {
            commit("SET_OCF18S_LOADING", false);
            commit("SET_OCF18S_PAGINATION", { total: 0, current: 1, data: [] });
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    getOcf18: function (_, ocf18Number) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .get(`hcai-ocf18s/${encodeURIComponent(ocf18Number)}`)
          .then(
            (res) => {
              resolve({ success: true, data: res.data.data });
            },
            (err) => {
              resolve({
                success: false,
                message:
                  ((err || {}).data || {}).message || "Something went wrong...",
              });
            }
          );
      });
    },
    saveOcf18: function (_, { ocf18Number, items }) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http
          .put(`hcai-ocf18s/${encodeURIComponent(ocf18Number)}/line-items`, {
            items,
          })
          .then(
            (res) => {
              resolve({ success: true, data: res.data });
            },
            (err) => {
              resolve({
                success: false,
                message:
                  ((err || {}).data || {}).message || "Something went wrong...",
              });
            }
          );
      });
    },
    // lineItemIds: submit only these line items (omit to submit every eligible one).
    submitOcf18: function (_, { ocf18Number, items, lineItemIds }) {
      const vm = this;
      const body = { items };
      if (lineItemIds) {
        body.line_item_ids = lineItemIds;
      }
      return new Promise((resolve) => {
        return vm.$http
          .post(`hcai-ocf18s/${encodeURIComponent(ocf18Number)}/submit`, body)
          .then(
            (res) => {
              resolve({ success: true, data: res.data });
            },
            (err) => {
              resolve({
                success: false,
                message:
                  ((err || {}).data || {}).message || "Something went wrong...",
                errors: ((err || {}).data || {}).errors || [],
              });
            }
          );
      });
    },
    // Submits every eligible line item matching the client (+ optional date range) filter.
    submitAllLineItems: function (_, filters) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post(`submit-all-hcai-line-items`, filters).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
              errors: ((err || {}).data || {}).errors || [],
            });
          }
        );
      });
    },
    // Edit (optional) + submit in one step — the only way to change a Failed/Rejected/PartiallyApproved item.
    submitLineItem: function (_, { id, edit }) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post(`hcai-line-items/${id}/submit`, edit || {}).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            });
          }
        );
      });
    },
    getLineItemHistory: function (_, id) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.get(`hcai-line-items/${id}/history`).then(
          (res) => {
            resolve({ success: true, data: res.data.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            });
          }
        );
      });
    },
    updateLineItem: function (_, { id, edit }) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.put(`hcai-line-items/${id}`, edit).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            });
          }
        );
      });
    },
    deleteLineItem: function (_, id) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.delete(`hcai-line-items/${id}`).then(
          (res) => {
            resolve({ success: true, data: res.data });
          },
          (err) => {
            resolve({
              success: false,
              message:
                ((err || {}).data || {}).message || "Something went wrong...",
            });
          }
        );
      });
    },
  },
};
